<template>
  <div
    class="rin-overlay"
    :class="{ 'rin-overlay--visible' : isVisible }">
    <div
      class="rin-overlay__background"
      :class="[
        { 'rin-overlay__background--image' : imageMode },
        { 'rin-overlay__background--clickable' : !disableSelfClosable },
      ]"
      @click.prevent="closeOverlay"></div>
    <div
      class="rin-overlay__container"
      :class="{ 'rin-overlay__container--image' : imageMode }">
      <InlineSVG
        v-if="!imageMode && !disableSelfClosable"
        class="rin-overlay__close"
        :src="closeIconPath"
        @click.prevent="closeOverlay" />
      <div
        class="rin-overlay__content"
        :class="{ 'rin-overlay__content--image' : imageMode }">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import TIcons from '@/types/TIcons';
  import InlineSVG from 'vue-inline-svg';

  export default {
    name: `Overlay`,
    components: { InlineSVG },
    data() {
      return {
        closeIconPath: TIcons.close,
      };
    },
    props: {
      disableSelfClosable: {
        default: false,
        type: Boolean,
      },
      imageMode: {
        default: false,
        type: Boolean,
      },
      isVisible: {
        default: false,
        required: true,
        type: Boolean,
      },
    },
    mounted() {
      window.addEventListener(`keyup`, this.onKeyUp);
    },
    beforeDestroy() {
      window.removeEventListener(`keyup`, this.onKeyUp);
    },
    methods: {
      closeOverlay() {
        if(!this.disableSelfClosable) {
          this.$emit(`close-overlay`);
        }
      },
      onKeyUp(event) {
        if(event.keyCode === 27) {
          this.closeOverlay();
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../assets/styles/rin-overlay';
</style>
